import { IApplicationState } from '../../types/redux';

export function getBanks(state: IApplicationState) {
  return state.newbuilding.banks;
}
